export var CONFLUENCE_GENERATOR_ID = 'https://www.atlassian.com/#Confluence';
export var JIRA_GENERATOR_ID = 'https://www.atlassian.com/#Jira';
// To support icons for all Jira task types.
export var JIRA_TASK = 'JiraTask';
export var JIRA_SUB_TASK = 'JiraSubTask';
export var JIRA_STORY = 'JiraStory';
export var JIRA_BUG = 'JiraBug';
export var JIRA_EPIC = 'JiraEpic';
export var JIRA_INCIDENT = 'JiraIncident';
export var JIRA_SERVICE_REQUEST = 'JiraServiceRequest';
export var JIRA_CHANGE = 'JiraChange';
export var JIRA_PROBLEM = 'JiraProblem';
export var JIRA_CUSTOM_TASK_TYPE = 'JiraCustomTaskType';

//List of provider keys that support theme modes for the embedded content.
export var PROVIDER_KEYS_WITH_THEMING = ['jira-object-provider', 'confluence-object-provider', 'watermelon-object-provider'];